export const INELIGIBLE = 'INELIGIBLE' as const;
export const CREDIT_CARD_NO_RECORD_FOUND = 'CREDIT_CARD_NO_RECORD_FOUND' as const;
export const CREDIT_CARD_DECLINED_PAYMENT = 'CREDIT_CARD_DECLINED_PAYMENT' as const;
export const SUBSCRIPTION_SERVICE_EXCEPTION = 'SUBSCRIPTION_SERVICE_EXCEPTION' as const;
export const CREDIT_CARD_EXPIRATION_DATE_IN_THE_PAST =
  'CREDIT_CARD_EXPIRATION_DATE_IN_THE_PAST' as const;
export const CREDIT_CARD_SECURITY_CODE_MALFORMED = 'CREDIT_CARD_SECURITY_CODE_MALFORMED' as const;
export const CREDIT_CARD_NUMBER_BAD_CHECKSUM = 'CREDIT_CARD_NUMBER_BAD_CHECKSUM' as const;
export const CREDIT_CARD_NUMBER_TOO_SHORT = 'CREDIT_CARD_NUMBER_TOO_SHORT' as const;
export const CREDIT_CARD_NUMBER_TOO_LONG = 'CREDIT_CARD_NUMBER_TOO_LONG' as const;
export const CREDIT_CARD_EXPYEAR_OUT_OF_RANGE = 'CREDIT_CARD_EXPYEAR_OUT_OF_RANGE' as const;
export const CREDIT_CARD_EXPMONTH_OUT_OF_RANGE = 'CREDIT_CARD_EXPMONTH_OUT_OF_RANGE' as const;
export const CREDIT_CARD_DECLINED_AUTHORIZATION = 'CREDIT_CARD_DECLINED_AUTHORIZATION' as const;
export const COUNTRY_CODE_INVALID = 'COUNTRY_CODE_INVALID' as const;
export const FAMILY_PLAN_ALREADY_MEMBER = 'FAMILY_PLAN_ALREADY_MEMBER' as const;
export const PRODUCT_INELIGIBLE = 'PRODUCT_INELIGIBLE' as const;
export const GIFT_CODE_INVALID = 'GIFT_CODE_INVALID' as const;
export const GIFT_CODE_REDEEMED = 'GIFT_CODE_REDEEMED' as const;
export const GIFT_CODE_REDEMPTION_ATTEMPTS_EXCEEDED =
  'GIFT_CODE_REDEMPTION_ATTEMPTS_EXCEEDED' as const;
export const GIFT_REQUIRES_PAYMENT_INFO = 'GIFT_REQUIRES_PAYMENT_INFO' as const;
export const GIFT_INELIGIBLE = 'GIFT_INELIGIBLE' as const;
export const INVALID_PRODUCT = 'INVALID_PRODUCT' as const;
export const TRIAL_INELIGIBLE_T3_FAMILY_PLAN_ELIGIBLE =
  'TRIAL_INELIGIBLE_T3_FAMILY_PLAN_ELIGIBLE' as const;
export const FAMILY_PLAN_AGE_INELIGIBLE = 'FAMILY_PLAN_AGE_INELIGIBLE' as const;
export const FAMILY_PLAN_SUB_ACCOUNT_SWITCHING_RESTRICTION_FAILED =
  'FAMILY_PLAN_SUB_ACCOUNT_SWITCHING_RESTRICTION_FAILED' as const;
export const ALREADY_SUBSCRIBED = 'ALREADY_SUBSCRIBED' as const;
export const USER_ALREADY_USED_TRIAL = 'USER_ALREADY_USED_TRIAL'; // NOTE = Only returned for 90 day promo; for no as constw
export const ALREADY_PREMIUM_INELIGIBLE =
  'Pandora Premium subscribers are not eligible to redeem gift codes' as const;
export const BANGO_ENTITLEMENT_ALREADY_ACTIVE = 'BANGO_ENTITLEMENT_ALREADY_ACTIVE' as const;
export const CARD_ALREADY_IN_USE = 'CARD_ALREADY_IN_USE' as const;
export const INSUFFICIENT_FUNDS_FOR_SUB = 'INSUFFICIENT_FUNDS_FOR_SUB' as const;
export const INSUFFICIENT_FUNDS_FOR_UPGRADE = 'INSUFFICIENT_FUNDS_FOR_UPGRADE' as const;

export const BLACKHAWK_SERVER_ERRORS = Object.freeze([
  CARD_ALREADY_IN_USE,
  INSUFFICIENT_FUNDS_FOR_SUB,
  INSUFFICIENT_FUNDS_FOR_UPGRADE,
] as const);
